export default function RunningText() {
    const items = [
        "गावली हॉस्पिटल कुरावर — 24 घंटे आपातकालीन चिकित्सा सुविधा उपलब्ध",
        "अनुभवी चिकित्सक • आधुनिक मशीनें • सुरक्षित एवं भरोसेमंद उपचार",
        "माता एवं शिशु देखभाल • हड्डी रोग • सामान्य रोग • शल्य चिकित्सा सेवाएं",
    ];

    return (
        <div className="w-full bg-[#0b3c78] py-3 overflow-hidden mt-8">
            <div className="marquee-outer">
                <div className="marquee-inner">
                    {[...items, ...items].map((text, index) => (
                        <div className="marquee-item" key={index}>
                            <span>{text}</span>
                        </div>
                    ))}
                </div>
            </div>

            <style>
                {`
          .marquee-outer {
            width: 100%;
            overflow: hidden;
          }

          .marquee-inner {
            display: flex;
            width: max-content;
            animation: scroll 28s linear infinite;
          }

          .marquee-item {
            white-space: nowrap;
            padding-right: 120px;
            color: white;
            font-size: 1.05rem;
            font-weight: 600;
          }

          @keyframes scroll {
            from {
              transform: translateX(0);
            }
            to {
              transform: translateX(-50%);
            }
          }
        `}
            </style>
        </div>
    );
}
